import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function NoData() {
  const { t } = useTranslation();

  return (
    <Paper sx={{ mt: 2, mb: 2, height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography sx={{ color: '#8080806b' }} variant="subtitle1">
        {t('No data to display')}
      </Typography>
    </Paper>
  );
}
